module.exports = __webpack_public_path__ + "static/media/logo-1.815f8980.png";